import {
  ErrorModal,
  HelmetDexteel,
  ShiftDayNavigatorControl,
  useShiftNavigator,
} from "@dexteel/mesf-core";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  LazyBackDropLoading,
  LazyLoading,
} from "../../../controls/LazyLoading";
import { NotificationSnackBar } from "../../../controls/snackbars/notification-snackbar";
import { EAFProcessesTable } from "./components/EAFProcessesTable";
import { useEAFProcessesContext } from "./context/EAFProcessesContext";
import { getProcessesByShift } from "./repositories/EAFRepository";

export const EAFProcessesPage = () => {
  const { shiftId: shiftIdParam } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const { state, actions } = useEAFProcessesContext();
  const [showDeletedProcesses, setShowDeletedProcesses] = useState(false);
  const { shiftInfo, getShiftDataFromAPI } = useShiftNavigator();

  const getDataFromAPI = async () => {
    actions.setIsLoadingGrid(true);
    const resp = await getProcessesByShift(
      shiftInfo?.CurrentShiftId || 0,
      showDeletedProcesses,
    );
    if (resp.ok && resp.data.tables.length > 0) {
      actions.setProcesses(get(resp, "data.tables[0].rows", []));
    } else {
      actions.setErrorMessage(resp.message);
    }
    actions.setIsLoadingGrid(false);
  };

  useEffect(() => {
    if (shiftInfo) {
      const shiftId = get(shiftInfo, "CurrentShiftId", null);
      if (state.processSelected && state.processSelected !== 0)
        navigate(
          `/eaf-processes/${shiftId}?processId=${state.processSelected}`,
        );
      else navigate(`/eaf-processes/${shiftId}`);
      (async () => {
        await getDataFromAPI();
      })();
    }
  }, [shiftInfo?.CurrentShiftId, state.processSelected, showDeletedProcesses]);

  useEffect(() => {
    if (shiftIdParam) {
      (async () => {
        const shiftId = Number(shiftIdParam);
        await getShiftDataFromAPI(null, shiftId);
      })();
    } else {
      (async () => {
        await getShiftDataFromAPI(null, 0);
      })();
    }
    const processId = params.get("processId");
    if (processId) {
      actions.setProcessSelected(Number(processId));
    }
  }, []);

  if (!state.isLoadingPage) {
    return (
      <>
        <HelmetDexteel
          title={`${shiftInfo?.CurrentStart.toLocaleDateString()} - EAF Processes`}
        />
        <LazyBackDropLoading open={state.isLoadingBackground} />
        <Grid container spacing={2} sx={{ p: 2 }}>
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              EAF Processes
            </Typography>
          </Grid>
          <Grid item md={12} xs={12}>
            <Paper sx={{ p: 2 }} elevation={2}>
              <Grid container alignItems="center">
                <Grid item sx={{ width: "fit-content" }}>
                  <ShiftDayNavigatorControl
                    preventInit
                    withPaper={false}
                    margin="0"
                  />
                </Grid>
                <Grid item sx={{ width: "fit-content", ml: 2 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showDeletedProcesses}
                        color="primary"
                        onChange={(event) =>
                          setShowDeletedProcesses(event.target.checked)
                        }
                      />
                    }
                    label="Show deleted processes"
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <EAFProcessesTable
              loadingGrid={state.isLoadingGrid}
              rows={state.processes || []}
              refreshData={getDataFromAPI}
            />
          </Grid>
        </Grid>
        <ErrorModal
          error={state.errorMessage}
          onHide={() => actions.setErrorMessage("")}
        />
        <NotificationSnackBar
          message={state.notificationMessage}
          onHide={() => actions.setNotificationMessage("")}
        />
      </>
    );
  }
  return <LazyLoading />;
};
